import { render, staticRenderFns } from "./ask-password-2.vue?vue&type=template&id=87f69458"
import script from "./ask-password-2.vue?vue&type=script&lang=js"
export * from "./ask-password-2.vue?vue&type=script&lang=js"
import style0 from "./ask-password-2.vue?vue&type=style&index=0&id=87f69458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports